var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29893 18.026L15.9455 11.3794C16.1408 11.1841 16.1408 10.8676 15.9455 10.6723L13.3277 8.05447C13.1324 7.8592 12.8159 7.8592 12.6206 8.05447L5.97398 14.7011C5.87761 14.7976 5.80915 14.9183 5.77587 15.0506L5.14352 18.2695C5.07502 18.6181 5.38187 18.925 5.73054 18.8565L8.94865 18.2241C9.08123 18.191 9.20251 18.1224 9.29893 18.026ZM18.5589 8.76604C18.8413 8.48352 19 8.10039 19 7.70091C19 7.30143 18.8413 6.9183 18.5589 6.63579L17.3642 5.4411C17.0817 5.15866 16.6986 5 16.2991 5C15.8996 5 15.5165 5.15866 15.234 5.4411L14.3928 6.28223C14.1976 6.47749 14.1976 6.79408 14.3928 6.98934L17.0107 9.60718C17.2059 9.80244 17.5225 9.80244 17.7178 9.60718L18.5589 8.76604Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.01361eb6.svg";
export { ForwardRef as ReactComponent };